module.exports = "https://p.cds.unp.clasificados.pe/lato-regular.a60a1daf25ba9505bd49b3468c9bd0fb.woff2";